module.exports = "<div *ngIf=\"showMask\" class=\"loading-mask\">\r\n    <div class=\"loading-mask-content\"></div>\r\n</div>";